import stats from '../../../stats/emitter';

const SUCCESS = 'success';
const FAILURE = 'failure';

/**
 * @param {Function}
 * @returns {Function}
 */
export const statsFunctionGenerator = (begin) =>

    /**
     * @param {Function} fn The function to time
     * @param {string} metric Full metric
     * @param {StatsOptions} options
     * @returns {Function} Wrapped function
     */
    function statsFunction(fn, metric, options = {}) {
        if (typeof fn !== 'function') {
            throw new TypeError(`First argument must be a function, instead got ${typeof fn} (${fn})`);
        }

        if (typeof metric !== 'string') {
            throw new TypeError(`Metric name must be a string, instead got ${typeof metric} (${metric}).`);
        }

        // Stats instance including first part of the metric name
        const prefixed = stats.prefix(metric);

        /**
         * @param {function} end Function returns time elapsed from start
         */
        const time = (end, suffix) => prefixed.time(
            suffix,
            end(),
            options
        );

        /**
         * @param {any*} args Original function's signature
         * @returns {any} Original function's return value
         */
        function wrappedFunction(...args) {
            const end = begin();
            try {
                const result = fn.apply(this, args);
                if (result instanceof Promise) {

                    // Register then/catch listeners to the promise
                    // (*) Registering "finally" triggers unhandledRejection even for caught errors
                    // If the caller does not set catch clause, unhandledRejection will still be triggered.
                    result
                        .then(
                            () => time(end, SUCCESS)
                        ).catch(
                            () => time(end, FAILURE)
                        );
                } else {
                    time(end, SUCCESS);
                }

                return result;
            } catch (error) {
                time(end, FAILURE);
                throw error;
            }
        }

        // Function name should reflect the wrapped function
        Object.defineProperty(
            wrappedFunction,
            'name',
            {
                get: () => `timed ${fn.name}`,
                configurable: true
            }
        );

        return wrappedFunction;
    };
